import React, { useState, useEffect } from 'react';
import '../AdminManager.css';

function SlideManager() {
  const [slides, setSlides] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingSlide, setEditingSlide] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    description: '',
    image: '',
    buttonText: 'Μάθετε Περισσότερα',
    buttonLink: '#services',
    order: 0,
    isActive: true,
  });

  useEffect(() => {
    fetchSlides();
  }, []);

  const fetchSlides = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/slides/all', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      setSlides(data);
    } catch (error) {
      console.error('Error fetching slides:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      const url = editingSlide
        ? `/api/slides/${editingSlide.id}`
        : '/api/slides';
      const method = editingSlide ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        fetchSlides();
        resetForm();
      }
    } catch (error) {
      console.error('Error saving slide:', error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Είστε σίγουροι;')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/slides/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        fetchSlides();
      }
    } catch (error) {
      console.error('Error deleting slide:', error);
    }
  };

  const handleEdit = (slide) => {
    setEditingSlide(slide);
    setFormData({
      title: slide.title,
      subtitle: slide.subtitle,
      description: slide.description || '',
      image: slide.image,
      buttonText: slide.buttonText,
      buttonLink: slide.buttonLink,
      order: slide.order,
      isActive: slide.isActive
    });
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData({
      title: '',
      subtitle: '',
      description: '',
      image: '',
      buttonText: 'Μάθετε Περισσότερα',
      buttonLink: '#services',
      order: 0,
      isActive: true,
    });
    setEditingSlide(null);
    setShowForm(false);
  };

  return (
    <div className="manager-container">
      <div className="manager-header">
        <h1 className="page-title">Hero Slides</h1>
        <button
          className="btn btn-primary"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? 'Ακύρωση' : '+ Νέο Slide'}
        </button>
      </div>

      {showForm && (
        <div className="form-card">
          <h2>{editingSlide ? 'Επεξεργασία Slide' : 'Νέο Slide'}</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Τίτλος *</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Υπότιτλος *</label>
                <input
                  type="text"
                  value={formData.subtitle}
                  onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Περιγραφή</label>
              <textarea
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows="3"
              />
            </div>

            <div className="form-group">
              <label>URL Εικόνας *</label>
              <input
                type="url"
                value={formData.image}
                onChange={(e) => setFormData({ ...formData, image: e.target.value })}
                placeholder="https://example.com/image.jpg"
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Κείμενο Κουμπιού</label>
                <input
                  type="text"
                  value={formData.buttonText}
                  onChange={(e) => setFormData({ ...formData, buttonText: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Link Κουμπιού</label>
                <input
                  type="text"
                  value={formData.buttonLink}
                  onChange={(e) => setFormData({ ...formData, buttonLink: e.target.value })}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Σειρά</label>
                <input
                  type="number"
                  value={formData.order}
                  onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
                />
              </div>
              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={formData.isActive}
                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                  />
                  Ενεργό
                </label>
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingSlide ? 'Ενημέρωση' : 'Δημιουργία'}
              </button>
              <button type="button" className="btn btn-outline" onClick={resetForm}>
                Ακύρωση
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="items-list">
        {slides.map((slide) => (
          <div key={slide.id} className="item-card">
            <div className="item-image">
              <img src={slide.image} alt={slide.title} />
            </div>
            <div className="item-content">
              <h3>{slide.title}</h3>
              <p className="item-subtitle">{slide.subtitle}</p>
              <div className="item-meta">
                <span className={`status-badge ${slide.isActive ? 'active' : 'inactive'}`}>
                  {slide.isActive ? 'Ενεργό' : 'Ανενεργό'}
                </span>
                <span>Σειρά: {slide.order}</span>
              </div>
            </div>
            <div className="item-actions">
              <button className="btn-icon" onClick={() => handleEdit(slide)}>
                ✏️
              </button>
              <button className="btn-icon" onClick={() => handleDelete(slide._id)}>
                🗑️
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SlideManager;
